module.exports = __webpack_public_path__ + "img/live.84f1663e.svg";